import { formatRelative, formatUtc } from '@vista-cloud/web-common';

/**
 * Duplicated in both dashboards, deliberately — and the distinction from
 * vista#671 matters, because that PR just removed two copies of the fetch
 * client for looking like this.
 *
 * What #671 consolidated was **behaviour**: a bugfix landed on one copy and not
 * the other, twice, and the divergence was invisible until something broke.
 * This file is presentation with no behaviour and no bugfix surface — if the
 * two copies drift visually, nothing misbehaves. The alternative is JSX in
 * `@vista-cloud/web-common`, which would cost a build step or a transform
 * config in both apps for markup neither app can get wrong.
 *
 * Anything with a decision in it goes in the shared package instead. That is
 * why the time FORMATTING lives there and `<RelativeTime>` does not.
 */

/**
 * The timestamp element `UI_GUIDELINES.md` §3.11 specifies: relative text with
 * the absolute UTC value on hover.
 *
 * A `<time>` rather than a `<span>` so the machine-readable value is in the
 * markup as well as the tooltip — a screen reader and a copy-paste both get the
 * real timestamp rather than "18m ago".
 *
 * The formatting lives in `@vista-cloud/web-common`; this is the React glue,
 * per the boundary vista#671 set (shared logic, per-app components). Six lines
 * of JSX is not what drifts — the formatting is, and it did.
 */
export default function RelativeTime({ ts, className, fallback = '—' }) {
  if (!ts) return <span className={className}>{fallback}</span>;
  const utc = formatUtc(ts);
  return (
    <time dateTime={ts} title={utc} className={className}>
      {formatRelative(ts)}
    </time>
  );
}
